import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
import shared from '../../../src/shared.js';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Screenshot = makeShortcode("Screenshot");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`From the web, you can delete your npm user account.`}</p>
    <ol>
      <li parentName="ol">
        <>{shared['user-login'].text}</>
        <>{shared['user-login'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['account-settings'].text}</>
        <>{shared['account-settings'].image}</>
      </li>
      <li parentName="ol">
        <p parentName="li">{`On this page, you will find a button to delete your account. Click that.`}</p>
        <Screenshot src="/getting-started/managing-your-npm-user-account/delete-your-account.png" alt="Screenshot of button to press to delete your account" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`You will now be presented with an overview of how many npm packages will be deleted and deprecated as part of your account deletion. If you agree with this, then enter your username and click "Delete this account".`}</p>
        <Screenshot src="/getting-started/managing-your-npm-user-account/account-deletion-confirmation.png" alt="Screenshot of the confirmation screen to delete an account." mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`You will be immediately logged out, and will not be able to log back in.`}</p>
      </li>
    </ol>
    <p>{`In some cases, you will be presented with an error if we were unable to automatically delete your account. For example. if you are the sole owner of an organization you will need to add an additional owner before your account can be deleted. You will be presented clear instructions of what you will need to do in order to delete your account.`}</p>
    <>If you are in doubt about deleting your account, {shared['contact-support'].text}</>.

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      